import { call, select } from 'redux-saga/effects'
import {getUserIdentity} from "state/app/selectors";
import {closeApplication} from "lib/native";

export default function* closeApplicationSaga(action) {
  const userIdentity = yield select(getUserIdentity);
  return yield call(closeApplication, userIdentity.get("platform"));
}



// WEBPACK FOOTER //
// ./src/state/app/sagas/closeApplication.js